<template>
  <div>
    <b-row>
      <b-col xl="4" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="FIO"
          name="Фамилия"
          v-slot="validationContext">
          <b-form-group
            id="input-group-35"
            label="Фамилия"
            label-for="input-35"
            :label-class="(!!passportForm.FIO) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-35"
              :class="(!!passportForm.FIO) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.FIO"
              placeholder="Фамилия"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="PersonName2"
          name="Имя"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Имя"
            label-for="input-36"
            :label-class="(!!passportForm.PersonName2) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!passportForm.PersonName2) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.PersonName2"
              placeholder="Имя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="PersonMiddleName"
          name="Отчество"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Отчество"
            label-for="input-36"
            :label-class="(!!passportForm.PersonMiddleName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!passportForm.PersonMiddleName) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.PersonMiddleName"
              placeholder="Отчество"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <custom-input
          ref="Sex"
          inputId="Sex"
          inputName="Пол"
          :inputItems="SexOptions"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
             { key: 'text', label: 'Пол' }
           ]"
          :loadOnFocus="true"
          select="text"
          :getData="() => { return promise.resolve() }"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="BirthDate"
          inputId="BirthDate"
          inputName="Дата рождения"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
      <b-col xl="4" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="BirthPlace"
          name="Место рождения"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Место рождения"
            label-for="input-36"
            :label-class="(!!passportForm.BirthPlace) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!passportForm.BirthPlace) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.BirthPlace"
              placeholder="Место рождения"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="RegSeries"
          name="Серия документа"
          :rules="{ max: 5 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-35"
            label="Серия документа"
            label-for="input-35"
            :label-class="(!!passportForm.RegSeries) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-35"
              :class="(!!passportForm.RegSeries) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.RegSeries"
              placeholder="Серия документа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <validation-provider
          ref="RegNum"
          name="Номер документа"
          :rules="{ regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-36"
            label="Номер документа"
            label-for="input-36"
            :label-class="(!!passportForm.RegNum) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-36"
              :class="(!!passportForm.RegNum) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.RegNum"
              placeholder="Номер документа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="RegDate"
          inputId="RegDate"
          inputName="Дата выдачи"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <validation-provider
          ref="Org_Code"
          name="Код подразделения"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-39"
            label="Код подразделения"
            label-for="input-39"
            :label-class="(!!passportForm.Org_Code) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-39"
              :class="(!!passportForm.Org_Code) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.Org_Code"
              placeholder="Код подразделения"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="8" md="8" sm="8" cols="12">
        <validation-provider
          ref="Org_Name"
          name="Наименование организации, выдавшей документ"
          :rules="{ max: 50 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-40"
            label="Организация, выдавшая документ"
            label-for="input-40"
            :label-class="(!!passportForm.Org_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-40"
              :class="(!!passportForm.Org_Name) ? 'form-input filled-field' : 'form-input'"
              v-model="passportForm.Org_Name"
              placeholder="Организация, выдавшая документ"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-subtitle">Место жительства</h4>
    <b-row>
      <b-col xl="8" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="RussianPerson_Region"
            inputId="RussianPerson_Region"
            inputName="Область (регион, штат, провинция и т.п.)"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="RussianPerson_City"
            :name="'Населенный пункт отправителя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-20"
              label="Населенный пункт"
              label-for="input-20"
              :label-class="(!!passportForm.RussianPerson_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-20"
                :class="(!!passportForm.RussianPerson_City) ? 'form-input filled-field' : 'form-input'"
                v-model="passportForm.RussianPerson_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="RussianPerson_StreetHouse"
            inputId="RussianPerson_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import CustomInput from '../../CustomInput'
  import CustomDatepicker from '../../CustomDatepicker'

  export default {
    name: "PassportPage",
    props: ['getValidationState', 'targetInput', 'passport', 'houseShipment', 'notForEdit'],
    components: {
      CustomInput,
      CustomDatepicker
    },
    data () {
      return {
        promise: window.Promise,
        passportForm: {
          did: null,
          RegSeries: null, // Серия документа, удостоверяющего личность
          RegNum: null, // Номер документа, удостоверяющего личность
          Org_Name: null, // Дата выдачи документа, удостоверяющего личность
          RegDate: null, // Наименование организации, выдавшей документ
          Org_Code: null, // Код подразделения
          FIO: null,
          PersonName2: null,
          PersonMiddleName: null,
          Sex: null,
          BirthDate: null,
          BirthPlace: null,
          RussianPerson_Region: null,
          RussianPerson_City: null,
          RussianPerson_StreetHouse: null,
        },
        SexOptions: [
          { value: '1', text: 'муж' },
          { value: '2', text: 'жен' },
        ],
      }
    },
    watch: {
      passport (val) {
        if (val) {
          this.passportForm = Object.assign(this.passportForm, val.data)
          this.passportForm.did = val.did
          for (let key in this.passportForm) {
            if ((key === 'RegDate') ||
                (key === 'BirthDate') ||
                (key === 'RussianPerson_Region') ||
                (key === 'RussianPerson_StreetHouse') ||
                (key === 'Sex')) {
              this.$refs[key].model = this.passportForm[key]
            }
          }
        }
      },
      'passportForm.RegSeries' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardSeries': newVal }) },
      'passportForm.RegNum' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardNumber': newVal }) },
      'passportForm.RegDate' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardDate': newVal, 'isCustom': true }) },
      'passportForm.Org_Name' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_OrganizationName': newVal }) },
    },
    computed: {
      ...mapState(
        {
        }
      )
    },
    mounted () {
      if (this.houseShipment) {
        for (let key in this.passportForm) {
          switch (key) {
            case 'RegNum':
              if (!this.passportForm.did && this.houseShipment.data.Consignee_IdentityCardNumber)
                this.passportForm.RegNum = this.houseShipment.data.Consignee_IdentityCardNumber
              break
            case 'RegSeries':
              if (!this.passportForm.did && this.houseShipment.data.Consignee_IdentityCardSeries)
                this.passportForm.RegSeries = this.houseShipment.data.Consignee_IdentityCardSeries
              break
            case 'Org_Name':
              if (!this.passportForm.did && this.houseShipment.data.Consignee_OrganizationName)
                this.passportForm.Org_Name = this.houseShipment.data.Consignee_OrganizationName
              break
            case 'RegDate':
              if (!this.passportForm.did && this.houseShipment.data.Consignee_IdentityCardDate)
                this.$refs[key].model = this.passportForm.RegDate = this.houseShipment.data.Consignee_IdentityCardDate
              break
          }
        }
      }
    },
    methods: {
      setModel (event) {
        this.passportForm[event.fieldName] = event.item
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      updateIdbData () {
        this.$emit('updatePassport')
      },
      resetFormData () {
        const props = Object.getOwnPropertyNames(this.passportForm)
        for (let i = 0; i < props.length; i++) {
          this.passportForm[props[i]] = null
          if (this.$refs[props[i]]) {
            this.$refs[props[i]].model = null
          }
        }
      },
      ...mapActions({
        getFreeBinaryDoc: 'commissionShipment/getFreeBinaryDoc',
        downloadFreeBinaryDocData: 'commissionShipment/downloadFreeBinaryDocData',
        createFreeBinaryDoc: 'commissionShipment/createFreeBinaryDoc',
        editFreeBinaryDoc: 'commissionShipment/editFreeBinaryDoc',
        deleteFreeBinaryDoc: 'commissionShipment/deleteFreeBinaryDoc',
        createInventoryDoc: 'commissionShipment/createInventoryDoc',
        editInventoryDoc: 'commissionShipment/editInventoryDoc',
        deleteInventoryDoc: 'commissionShipment/deleteInventoryDoc'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .reset-file-btn {
    height: 28px;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  hr {
    margin-top: 0 !important;
  }
</style>
